import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  TOAST_SEVERITY,
  useToast,
} from '@src/app/notifications/toast';
import { useAuthentication } from '@src/features/auth';
import { NotificationsIcon } from '@src/shared/ui/icons';

import {
  useAcknowledgeAlertNotifications,
  useAlertSummary,
} from '../model';

export default function NewAlertNotificationController() {
  const { t } = useTranslation();
  const { dismiss, show } = useToast();
  const { user } = useAuthentication();
  const userId = user?.id;
  const { data } = useAlertSummary(userId);
  const { mutate: acknowledge } = useAcknowledgeAlertNotifications(userId);
  const toastIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!data?.has_new_actionable_alerts) {
      if (toastIdRef.current) {
        dismiss(toastIdRef.current);
        toastIdRef.current = null;
      }
      return;
    }

    if (toastIdRef.current) {
      return;
    }

    toastIdRef.current = show(
      t('alerts.new_alert_notification', 'New Alert!'),
      TOAST_SEVERITY.WARNING,
      {
        duration: 0,
        dismissOnClick: true,
        onClick: () => acknowledge(),
        icon: <NotificationsIcon color="inherit" />,
      },
    );
  }, [acknowledge, data?.has_new_actionable_alerts, dismiss, show, t]);

  useEffect(
    () => () => {
      if (toastIdRef.current) {
        dismiss(toastIdRef.current);
      }
    },
    [dismiss],
  );

  return null;
}
